import {useState} from 'react'
import {useNavigate} from 'react-router'
import {PATHS} from '@freckle/educator-entities/ts/common/helpers/paths'
import {Container} from '@freckle/educator-materials/ts/components/container'
import {Flex} from '@freckle/educator-materials/ts/components/flex'
import {Image} from '@freckle/educator-materials/ts/components/img'
import {Link} from '@freckle/educator-materials/ts/components/link'
import {SpinnerOverlay} from '@freckle/educator-materials/ts/components/spinner'
import {Text} from '@freckle/educator-materials/ts/components/typography'
import {H2, H3} from '@freckle/educator-materials/ts/components/typography'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import ApiHelper from '@freckle/school/ts/common/helpers/api-helper'
import Notification from '@freckle/school/ts/common/helpers/notification'
import {Routes} from '@freckle/school/ts/common/routers/routes'
import {
  logo,
  cardWrapper,
  wrapper,
  pageWrapper,
  mutedTitle,
  lockedImage,
  lockedCard,
  card
} from './app-selection-page.module.scss'

export function AppSelectionPage() {
  const {t} = useSafeTranslation()
  const history = useNavigate()
  const [loading, setLoading] = useState(false)
  return (
    <Flex flexDirection="column" alignItems="center" className={pageWrapper}>
      <Image
        src={`${PATHS.imageAssetsUrl}/company-logos/renaissance-freckle-logo.svg`}
        alt={t('COMMON_FRECKLE_LOGO_IMAGE_LINK_ALT_TEXT')}
        title={t('COMMON_FRECKLE_LOGO_IMAGE_LINK_TITLE_TEXT')}
        width="184"
        className={logo}
      />
      <H2>{t('APP_SELECTION_PAGE_TITLE')}</H2>
      <Container size="lg" className={cardWrapper}>
        <Flex className={wrapper} justifyContent="space-evenly" flexWrap="wrap">
          <Card
            title={t('APP_SELECTION_PAGE_ADMINISTRATOR_OPTION_TEXT')}
            icon="sign-up-admin.svg"
            content={t('APP_SELECTION_PAGE_ADMINISTRATOR_OPTION_DESCRIPTION_TEXT')}
            disabled={loading}
            onClick={() => {
              setLoading(true)
              history(Routes.dashboard(), {replace: true})
              // Don't worry about turning off loading
            }}
          />

          <Card
            title={t('APP_SELECTION_PAGE_TEACHER_OPTION_TEXT')}
            icon="sign-up-teacher.svg"
            content={t('APP_SELECTION_PAGE_TEACHER_OPTION_DESCRIPTION_TEXT')}
            disabled={loading}
            onClick={() => {
              setLoading(true)
              ApiHelper.reloginAsTeacher().then(
                ({redirectUrl}) => {
                  document.location.assign(redirectUrl)
                  // Don't worry about turning off loading
                },
                () => {
                  setLoading(false)
                  Notification.displayErrorNotification(t('APP_SELECTION_PAGE_ERROR_MESSAGE_TEXT'))
                }
              )
            }}
          />
          {loading ? <SpinnerOverlay /> : null}
        </Flex>
        <Link href={Routes.ssoLogoutToRenaissance()} reactRouter={false}>
          {t('APP_SELECTION_PAGE_HOME_LINK_TEXT')}
        </Link>
      </Container>
    </Flex>
  )
}

function Card({
  content,
  title,
  icon,
  disabled,
  onClick
}: {
  content: string
  title: string
  icon: string
  disabled: boolean
  onClick: () => void
}) {
  const titleClass = disabled ? mutedTitle : undefined
  const imageClass = disabled ? lockedImage : undefined
  const cardClass = disabled ? lockedCard : card
  return (
    <>
      <Container size="md" className={cardClass} onClick={disabled ? undefined : onClick}>
        <Flex flexDirection="column" justifyContent="center" alignItems="center">
          <Image className={imageClass} src={`${PATHS.imageAssetsUrl}/icons/${icon}`} width="70" />

          <H3 className={titleClass}>{title}</H3>
          <Text style="body-2" modifiers={['muted', 'centered']} htmlElement="span">
            {content}
          </Text>
        </Flex>
      </Container>
    </>
  )
}
